import { formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

// Русское склонение для суффикса "назад": винительный падеж для "1"
// (минуту, час, день...), родительный для 2-4 и множественного.
function plural(count, [accusative, genitiveSingular, genitivePlural]) {
    const rem10 = count % 10;
    const rem100 = count % 100;

    if (rem10 === 1 && rem100 !== 11) return accusative;
    if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return genitiveSingular;
    return genitivePlural;
}

const forms = {
    Seconds: ['секунду', 'секунды', 'секунд'],
    Minutes: ['минуту', 'минуты', 'минут'],
    Hours: ['час', 'часа', 'часов'],
    Days: ['день', 'дня', 'дней'],
    Weeks: ['неделю', 'недели', 'недель'],
    Months: ['месяц', 'месяца', 'месяцев'],
    Years: ['год', 'года', 'лет'],
};

const withCount = (count, key) => `${count} ${plural(count, forms[key])}`;

// Кастомный formatDistance без неточных слов "около", "менее", "меньше",
// с корректным склонением существительных.
function formatDistance(token, count, options = {}) {
    let result;

    switch (token) {
        case 'lessThanXSeconds':
        case 'xSeconds':
            result = withCount(count, 'Seconds');
            break;
        case 'halfAMinute':
            result = 'полминуты';
            break;
        case 'lessThanXMinutes':
        case 'xMinutes':
            result = withCount(count, 'Minutes');
            break;
        case 'aboutXHours':
        case 'xHours':
            result = withCount(count, 'Hours');
            break;
        case 'xDays':
            result = withCount(count, 'Days');
            break;
        case 'aboutXWeeks':
        case 'xWeeks':
            result = withCount(count, 'Weeks');
            break;
        case 'aboutXMonths':
        case 'xMonths':
            result = withCount(count, 'Months');
            break;
        case 'aboutXYears':
        case 'xYears':
        case 'overXYears':
        case 'almostXYears':
            result = withCount(count, 'Years');
            break;
        default:
            result = '';
    }

    if (options.addSuffix) {
        return options.comparison > 0 ? `через ${result}` : `${result} назад`;
    }

    return result;
}

const localeRu = { ...ru, formatDistance };

function FormatDateDistanceToNow({ dateString }) {
    const date = new Date(dateString);
    const formattedDate = formatDistanceToNow(date, {
        addSuffix: true,
        includeSeconds: true,
        locale: localeRu,
    });

    return <span>{formattedDate}</span>;
}

export default FormatDateDistanceToNow
